"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _util = require("util");
var _loggerProxy = _interopRequireDefault(require("../logs/logger-proxy"));
var EventsUtil = {};
EventsUtil.getEventLog = function (args) {
  var argString = '';
  try {
    argString = (0, _util.inspect)(args);
  } catch (e) {
    _loggerProxy.default.logger.warn("Events:util#getEventLog --> ".concat(e));
  }
  return argString;
};
EventsUtil.getScopeLog = function (scope) {
  var scopeString = '';
  if (scope) {
    if (scope.file && scope.function) {
      scopeString += "".concat(scope.file, ":").concat(scope.function, "->");
      return scopeString;
    }
    if (scope.file) {
      scopeString += "".concat(scope.file, "->");
    }
    if (scope.function) {
      scopeString += "".concat(scope.function, "->");
    }
  }
  return scopeString;
};
var _default = EventsUtil;
exports.default = _default;
//# sourceMappingURL=util.js.map
